import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const ParkingIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon viewBox="0 0 44 44" fill="none" {...props}>
    <path
      d="M41 2V41H2V2H41ZM39.2396 3.76042H3.96354C3.94865 3.76042 3.76042 3.94865 3.76042 3.96354V39.2396H39.2396V3.76042Z"
      fill="currentColor"
    />

    <path
      d="M18.6389 24.7513V32.6957H14.5139V11.918H24.3681C30.0514 11.918 32.7984 19.5339 28.3372 23.2205C27.7093 23.7399 25.7431 24.7513 24.9792 24.7513H18.6389ZM18.6389 21.3902H24.0625C24.1206 21.3902 24.9991 21.0159 25.1366 20.9364C27.1227 19.7998 26.8171 16.2584 24.5698 15.5342C24.4292 15.4884 23.5186 15.2776 23.4514 15.2776H18.6389V21.3887V21.3902Z"
      fill="currentColor"
    />
  </SvgIcon>
);
